import { useState } from 'react'
import {
  ActiveImage,
  ImageGalleryContainer,
  Thumbnail,
  ThumbnailContainer,
} from './style'

const ImageGallery = ({ images }) => {
  const [activeImage, setActiveImage] = useState(images[0])

  return (
    <ImageGalleryContainer>
      <ActiveImage src={`${process.env.BUCKET_URL}/${activeImage}`} />
      <ThumbnailContainer>
        {images.map((image, index) => (
          <Thumbnail
            key={index}
            src={`${process.env.BUCKET_URL}/${image}`}
            active={activeImage === image}
            onClick={() => setActiveImage(image)}
          />
        ))}
      </ThumbnailContainer>
    </ImageGalleryContainer>
  )
}

export default ImageGallery
